<template>
    <card class="tw-text-center">
        <div class="tw-py-2">
            <stepper :steps="PROCESS_MODEL_STEPS" :current-step="currentStep"></stepper>
        </div>
    </card>
</template>

<script>
import Card from '@/modules/shared/components/ui/Card/Card';
import Stepper from '@/modules/shared/components/ui/stepper/Stepper';
import { PROCESS_MODEL_STEPS } from '../../constants/constants';

function data() {
	return {
		PROCESS_MODEL_STEPS,
	};
}
function stepClass() {
	return step => ({
		completed: this.PROCESS_MODEL_STEPS.indexOf(step) < this.currentStep - 1,
	});
}

export default {
	name: 'process-model-stepper',
	components: {
		Card,
		Stepper,
	},
	props: ['currentStep'],
	data,
	computed: {
		stepClass,
	},
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/modules/evaluation-360/components/process/process-model-stepper.vue